import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
  standalone: true,
  imports: [RouterOutlet],
})
export class AuthLayoutComponent implements OnInit, OnDestroy {
  private resizeListener!: () => void;

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    this.setRealVh();

    this.resizeListener = this.renderer.listen('window', 'resize', () => {
      this.setRealVh();
    });
  }

  ngOnDestroy(): void {
    if (this.resizeListener) {
      this.resizeListener();
    }
  }

  private setRealVh(): void {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--real-vh', `${vh}px`);
  }
}
